import React, { useState } from "react";

import { useGetSearchHistory } from "./useGetSearchHistory";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Loader from "src/app/components/Loader/Loader";
import SearchHistoryPaneListItem from "./SearchHistoryPaneListItem";

interface SearchHistoryListProps {
  fromDate: string;
  projectId: string;
}

function SearchHistoryList({ fromDate, projectId }: SearchHistoryListProps) {
  const { data, isLoading } = useGetSearchHistory(fromDate);
  const [editingItemUuid, setEditingItemUuid] = useState<string | null>(null);

  if (isLoading) {
    return (
      <div className="search-history__loading">
        <Loader />
      </div>
    );
  }

  if (data?.content) {
    const items = data.content;

    const isEmpty = !items || items.length === 0;

    if (isEmpty) {
      return (
        <p className="search-history-pane__placeholder">
          <IDHFormattedMessage
            id="ws_no_search_history"
            defaultMessage="No search history available"
          />
        </p>
      );
    }

    return (
      <ul className="search-history-pane__list">
        {items.map((item) => (
          <SearchHistoryPaneListItem
            key={item.uuid}
            item={item}
            projectId={projectId}
            editingItemUuid={editingItemUuid}
            setEditingItemUuid={setEditingItemUuid}
          />
        ))}
      </ul>
    );
  }

  return null;
}

export default SearchHistoryList;
